import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.expander-container {
  max-width: 544px;
  margin: 0 auto;
}
.expander-container :global(ul) {
    padding: 0;
}
.see-all-link {
    display: block;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    color: #086ea1;
    padding-top: calc(8px * 3);
    padding-bottom: calc(8px * 3);
}
ul {
    list-style-type: none;
    padding: 0;
}
img {
    float: right;
    padding-top: 8px;
}
button {
    padding: calc(8px * 2);
    text-align: left;
    width: 100%;
    font-weight: bold;
}
.accordion-title {
    font-family: 'Nimbus Sans', normal;
    font-size: 20px;
    color: #56646b;
}
.expander-sectional {
    margin: 0 auto 2px auto;
    background-color: #ffffff;
}
.expander-sectional button:focus {
    border: 2px solid #000000;
}
.expanded {
    margin-bottom: calc(8px * 2);
    border-top: #05c3de 4px solid;
    padding-bottom: 8px;
}
.expanded-btn {
    border-bottom: #ebebeb 1px solid;
}
.expander-subtext {
    display: block;
    line-height: 22px;
    padding-top: 8px;
    font-weight: normal;
    color: #6b7880;
}
`;

export default styles;